import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/AppTypes";
import { webSiteService, IWebSiteDetails, IWebSiteSeachFields } from "./webSiteService";

interface IKeyWordsDrawerType {
    visible: boolean,
    mode: "add" | "edit",
    record?: IWebSiteDetails
}

export const useWebSiteModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IWebSiteDetails[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IWebSiteSeachFields>({});

    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IWebSiteSeachFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await webSiteService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        return records;
    }

    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
    }

    /* 详情*/
    const [detailDrawer, serDetailDrawer] = useState<IKeyWordsDrawerType>({ visible: false, mode: "add" });

    return {
        /***field***/
        searchParam,
        dataSource,
        pgCfg,
        /***method***/
        setDataSource,
        setSearchParam,
        loadData,
        updateSearchParam,
        resetSearchParam,
        detailDrawer, serDetailDrawer
    }
});